import { render, staticRenderFns } from "./FindDiff.vue?vue&type=template&id=bc027472&scoped=true&"
import script from "./FindDiff.vue?vue&type=script&lang=js&"
export * from "./FindDiff.vue?vue&type=script&lang=js&"
import style0 from "./FindDiff.vue?vue&type=style&index=0&id=bc027472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc027472",
  null
  
)

export default component.exports